import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource
import banko.composeapp.generated.resources.Res
import banko.composeapp.generated.resources.*

@Composable
internal fun StartGameHostAction(
    playerCount: Int,
    buttonHeight: Dp,
    onStartGame: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val canStart = playerCount > 1
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(if (canStart) 0.dp else 6.dp),
    ) {
        GlossyPrimaryButton(
            text = stringResource(Res.string.start_game),
            onClick = onStartGame,
            enabled = canStart,
            modifier = Modifier
                .fillMaxWidth()
                .height(buttonHeight),
        )
        if (!canStart) {
            Text(
                text = stringResource(Res.string.start_game_needs_players_hint),
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textAlign = TextAlign.Center,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}
